<template>
  <div class="login_w">
    <div class="bc_fff">
      <div
        class="header_w site_content d_flex align_item_c justify_content_sb"
        style="padding: 24px 0"
      >
        <div class="d_flex align_item_c">
          <router-link to="/" class="d_inline_flex align_item_c cursor_pointer">
            <img :src="siteInfo.logo" class="img_1" alt="" />
          </router-link>
          <span class="span_2" />
          <span class="span_1 fz16 c_808080">用户登录</span>
        </div>

        <div class="d_flex align_item_c">
          <img src="@/assets/images/login_2.png" alt="" />
          <span class="span_3 fz16 c_0983CC">{{ siteInfo.hotline }}</span>
        </div>
      </div>
    </div>
    <div
      class="content_w"
      :style="{
        background: `url(${oss_pub_domain}business/project/land/v70fxfZ208Fe6fxe.png) 100% center/cover no-repeat`,
      }"
    >
      <div class="div_2 site_content d_flex justify_content_end align_item_c">
        <div class="login_c_w">
          <el-tabs v-model="activeName" type="border-card">
            <el-tab-pane label="账号登录" name="accountLoginForm">
              <div class="prompt02">
                <div class="moving-text-container02">
                  <p class="moving-text02">
                    本平台为互联网非涉密平台，严禁处理、传输国家秘密
                  </p>
                </div>
              </div>
              <el-form
                ref="accountLoginForm"
                :model="accountLoginForm"
                :rules="rules"
                label-position="left"
                label-width="56px"
              >
                <el-form-item prop="account" label="账号">
                  <el-input
                    v-model="accountLoginForm.account"
                    placeholder="请输入账号"
                    :maxlength="input_l_150"
                  />
                </el-form-item>
                <el-form-item
                  prop="password"
                  style="margin-bottom: 15px"
                  label="密码"
                >
                  <el-input
                    v-model="accountLoginForm.password"
                    placeholder="请输入密码"
                    :type="passwordInputType"
                    @keyup.enter.native="
                      onSubmitAccountLogin('accountLoginForm')
                    "
                    @input="onPasswordInput"
                  >
                    <i
                      slot="suffix"
                      class="el-input__icon el-icon-view fz18 cursor_pointer"
                      @click="onVisiablePassword"
                    />
                  </el-input>
                </el-form-item>
              </el-form>

              <div class="d_flex justify_content_sb align_item_c">
                <el-checkbox
                  v-model="accountLoginForm.rememberMe"
                  class="c_1A1A1A"
                  @change="setrememberMe"
                  >记住密码</el-checkbox
                >
                <router-link to="/findpsw" class="fz14 c_1A1A1A"
                  >忘记密码?</router-link
                >
              </div>

              <div
                class="button_1 bc_0983CC fz14 c_fff text_center cursor_pointer"
                @click="onSubmitAccountLogin('accountLoginForm')"
              >
                登录
              </div>

              <div @click="onRegisterClick">
                <div
                  class="
                    button_2
                    bc_fff
                    fz14
                    c_1A1A1A
                    text_center
                    cursor_pointer
                  "
                >
                  注册
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="手机登录" name="phoneLoginForm">
              <div class="prompt02">
                <div class="moving-text-container02">
                  <p class="moving-text02">
                    本平台为互联网非涉密平台，严禁处理、传输国家秘密
                  </p>
                </div>
              </div>
              <el-form
                ref="phoneLoginForm"
                :model="phoneLoginForm"
                :rules="rules"
                label-position="right"
                label-width="90px"
                class="form_1"
                @validate="onValidateForm"
              >
                <el-form-item prop="phone" label="手机号码">
                  <el-input
                    v-model="phoneLoginForm.phone"
                    placeholder="请输入手机号码"
                  />
                </el-form-item>
                <el-form-item
                  prop="smscode"
                  style="margin-bottom: 15px"
                  label="验证码"
                  class="vcode_form_item"
                >
                  <el-input
                    v-model="phoneLoginForm.smscode"
                    placeholder="请输入验证码"
                    :maxlength="input_l_150"
                    @keyup.enter.native="onSubmitPhoneLogin('phoneLoginForm')"
                  />

                  <div
                    :class="
                      countDown < 60 || !passPhone
                        ? 'disabled_btn send_vcode_btn'
                        : 'send_vcode_btn is_active'
                    "
                    @click="onSendVcodeClick"
                  >
                    <span v-if="countDown === 60">获取验证码</span>
                    <span v-else>{{ countDown }}s后重新获取</span>
                  </div>
                </el-form-item>
              </el-form>

              <!-- <div class="d_flex justify_content_end align_item_c">
                <router-link
                  to="/findpsw"
                  class="fz14 c_1A1A1A"
                >忘记密码?</router-link>
              </div> -->

              <div
                class="button_1 bc_0983CC fz16 c_fff text_center cursor_pointer"
                @click="onSubmitPhoneLogin('phoneLoginForm')"
              >
                登录
              </div>

              <div @click="onRegisterClick">
                <div
                  class="
                    button_2
                    bc_fff
                    fz16
                    c_1A1A1A
                    text_center
                    cursor_pointer
                  "
                >
                  注册
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <MyFooter />

    <!-- 注册须知 -->
    <AgreementRead v-model="registerReadModal" @onCancal="onCancal" />
  </div>
</template>

<script>
import MyFooter from "@/views/public_0983cc/MyFooter.vue";
import AgreementRead from "@/components/template/AgreementRead.vue";
import { user_login, user_quickLogin } from "@/api/login";
import { user_gee_web_init } from "@/api/public";
import { user_sms_quickLogin } from "@/api/sms";
import { mapMutations, mapActions } from "vuex";
import Cookies from "js-cookie";
import { isvalidPhone } from "@/utils";
import { encrypt, decrypt } from "@/utils/rsaEncrypt";
import { mapGetters } from "vuex";
import { _input_l_150, _input_l_300, _input_l_500 } from "@/utils/setting";
export default {
  components: { MyFooter, AgreementRead },
  inject: ["reload"],

  data() {
    const validPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号码"));
      } else if (!isvalidPhone(value)) {
        callback(new Error("请输入正确的手机号码"));
      } else {
        callback();
      }
    };

    return {
      activeName: "accountLoginForm",
      accountLoginForm: {
        password: "",
        account: "",
      },
      phoneLoginForm: {},
      rules: {
        account: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        phone: [{ required: true, trigger: "change", validator: validPhone }],
        smscode: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      countDown: 60, // 5分钟
      countDownTimer: null,

      passwordInputType: "password",
      passPhone: false,

      registerReadModal: false, // 注册须知框
    };
  },
  computed: {
    ...mapGetters(["siteInfo", "oss_pub_domain"]),
    input_l_150() {
      return _input_l_150;
    },
    input_l_300() {
      return _input_l_300;
    },
    input_l_500() {
      return _input_l_500;
    },
  },
  watch: {
    activeName: function (n, o) {
      this.$refs[this.activeName].clearValidate();
    },

    // 当账户密码改变时，需重新记住
    "accountLoginForm.account": function (n, o) {
      if (!o) return;
      this.accountLoginForm.rememberMe = false;
      this.setrememberMe();
    },

    // 加密
    "accountLoginForm.rememberMe": function (n) {
      if (n) {
        console.log("设置");
        localStorage.setItem("_p", encrypt(this.accountLoginForm.account));
        localStorage.setItem("_d", encrypt(this.accountLoginForm.password));
      } else {
        localStorage.removeItem("_p");
        localStorage.removeItem("_d");
      }
    },
  },
  created() {
    this.getrememberMe();
    // 解密
    this.getDecrypt();

    console.log(this.$route);
  },
  methods: {
    ...mapMutations({
      setUserinfo: "user/setUserinfo",
      setTokenExpTime: "app/setTokenExpTime",
      setToken: "user/setToken",
    }),
    ...mapActions({
      doAccountLogin: "user/doAccountLogin",
      doPhoneLogin: "user/doPhoneLogin",
    }),
    // 密码改变时
    onPasswordInput(val) {
      if (val) {
        this.accountLoginForm.rememberMe = false;
      }
    },

    // 发送验证码 click
    async onSendVcodeClick() {
      if (this.countDown < 60 || !this.passPhone) return;

      const { data } = await user_gee_web_init();

      await initGeetest(
        {
          // 以下配置参数来自服务端 SDK
          gt: data.gt,
          challenge: data.challenge,
          offline: !data.success,
          new_captcha: true,
          product: "bind",
        },
        (captchaObj) => {
          captchaObj
            .onReady(() => {
              captchaObj.verify(); // 显示验证码
            })
            .onSuccess(() => {
              this.sendValidCode(captchaObj.getValidate(), data);
            })
            .onError(() => {});
        }
      );
    },
    // 发送验证码 api
    async sendValidCode(validDate, firstValidRes) {
      const res = await user_sms_quickLogin({
        ...validDate,
        geeuser: firstValidRes.geeuser,
        phone: this.phoneLoginForm.phone,
      });
      if (res.code === 200) {
        this.countDownTimer = setInterval(() => {
          this.countDown--;
          if (this.countDown < 1) {
            this.countDown = 60;
            clearInterval(this.countDownTimer);
          }
        }, 1000);
      }
    },

    // 切换密码可见 click
    onVisiablePassword() {
      this.passwordInputType =
        this.passwordInputType === "password" ? "text" : "password";
    },

    // 账号登录 click
    onSubmitAccountLogin(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.doAccountLogin(this.accountLoginForm).then(() => {
            this.handleLoginSuccess();
          });
        }
      });
    },
    // 手机登录 click
    onSubmitPhoneLogin(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.doPhoneLogin(this.phoneLoginForm).then(() => {
            this.handleLoginSuccess();
          });
        }
      });
    },
    // 处理登录成功
    handleLoginSuccess(res) {
      if (this.$route.query.returnUrl) {
        this.$router.push({
          path: this.$route.query.returnUrl,
        });
      } else {
        this.$router.push("/");
      }
      this.reload();
    },
    // 触发表单校验时
    onValidateForm(prop, isValid, err) {
      if (prop === "phone") {
        this.passPhone = isValid;
      }
    },

    // 注册点击 click
    onRegisterClick() {
      this.$router.push({
        query: {
          returnUrl: "/login",
        },
        path: "/register",
      });
    },
    // 取消须知
    onCancal(n) {
      this.registerReadModal = n;
    },

    // 设置记住密码
    setrememberMe() {
      localStorage.setItem("rememberMe", this.accountLoginForm.rememberMe);
    },
    // 获取记住密码
    getrememberMe() {
      this.$set(
        this.accountLoginForm,
        "rememberMe",
        JSON.parse(localStorage.getItem("rememberMe"))
      );
    },
    // 密码解密
    getDecrypt() {
      if (this.accountLoginForm.rememberMe) {
        this.accountLoginForm.password = decrypt(
          JSON.parse(JSON.stringify(localStorage.getItem("_d")))
        );

        this.accountLoginForm.account = decrypt(
          JSON.parse(JSON.stringify(localStorage.getItem("_p")))
        );

        // console.log(this.accountLoginForm)
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.prompt02 {
  width: 390px;
  position: relative;
  display: flex;
  left: -19px;
  top:-30px
}
.moving-text-container02 {
  width: 100%; /* 根据需要设置宽度 */
  overflow: hidden; /* 隐藏超出容器的部分 */
  white-space: nowrap; /* 防止文字换行 */
  position: relative; /* 便于子元素定位 */
}

.moving-text02 {
  font-size: 16px;
  margin-top: 1px;
  color: rgb(230, 46, 46);
  font-weight: bold;
}
.login_w {
  .content_w {
    min-width: 1360px;
    height: 686px;

    .site_content {
      height: 100%;
    }
  }

  .img_1 {
    // width: 321px;
    // height: 51px;
  }
  .span_1 {
    margin: 0 0 0 21px;
  }
  .span_2 {
    display: inline-block;
    height: 52px;
    margin: 0 0 0 20px;
    border-right: 1px dashed #e6e6e6;
  }
  .span_3 {
    margin: 0 0 0 10px;
  }
  .div_1 {
    margin: 0 21px 0 0;
  }
  .div_2 {
    position: relative;
  }
  .button_1,
  .button_2 {
    padding: 16px 0;
  }
  .button_1 {
    margin: 20px 0 10px 0;
    &:active {
      background-color: rgba($color: #0983cc, $alpha: 0.9);
    }
  }
  .button_2 {
    border: 1px solid #e6e6e6;
    &:active {
      background-color: rgba($color: #e6e6e6, $alpha: 0.9);
    }
  }
  .form_1 {
    margin-left: -35px;
  }
  .login_c_w {
    position: absolute;
    top: 100px;
    right: -60px;
    background: #ffffff;
    border-radius: 5px;
    box-sizing: border-box;

    .login_btn {
      width: 100%;
      margin: 57px 0 0 0;
      height: 32px;
      background: #2caeff;
    }

    .vcode_form_item .el-form-item__content {
      & > .el-input {
        width: 172px;
      }
    }
    .send_vcode_btn {
      display: inline-block;
      width: 110px;
      background: #0983cc;
      color: #fff;
      padding: 2px 0;
      text-align: center;
      margin: 0 0 0 13px;
      font-size: 14px;
      cursor: pointer;
    }
    .send_vcode_btn.is_active {
      &:active {
        background-color: rgba($color: #0983cc, $alpha: 0.9);
      }
    }

    .vscode_input_w {
      position: relative;
      .el-button {
        position: absolute;
        right: 11px;
        top: 0;
        bottom: 0;
        margin: auto;
      }
    }
    .login_options {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px;
    }
  }

  ::v-deep .el-form-item__label {
    font-size: 14px;
    line-height: 44px;
    color: #1a1a1a;
  }
  ::v-deep .el-input__inner {
    height: 44px;
    line-height: 44px;
    border: 1px solid #e6e6e6;
    ::-webkit-input-placeholder {
      /* Chrome/Safari/Opera */
      font-size: 16px;
    }
    ::-moz-placeholder {
      /* Firefox 19+ */
      font-size: 16px;
    }
    // :-ms-input-placeholder {
    //   /* IE 10+ 注意这里只有一个冒号 */
    //   font-size: 16px;
    // }
  }

  ::v-deep .el-tabs {
    width: 430px;
    height: 440px;
    background: #ffffff;
    box-shadow: 0px 0px 8px 0px rgba(189, 189, 189, 0.3);
  }
  ::v-deep .el-tabs__content {
    height: 388px;
    padding: 48px 40px 40px 40px;
    box-sizing: border-box;
    border-top: 1px solid #dcdfe6;
  }
  ::v-deep .el-tabs__nav {
    width: 100%;
  }
  ::v-deep .el-tabs__item {
    width: 50%;
    height: 66px;
    text-align: center;
    line-height: 66px;
    font-size: 18px;
  }
  ::v-deep .el-tabs--border-card > .el-tabs__header {
    border: none;
  }
  ::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item {
    color: #1a1a1a;
    border: none;
    margin-left: 0;
    &:first-child {
      border-right: 1px solid #dcdfe6;
    }
  }
  ::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    font-weight: bold;
  }
  ::v-deep
    .el-tabs--border-card
    > .el-tabs__header
    .el-tabs__item:not(.is-disabled):hover {
    color: #1a1a1a;
  }
}
</style>
